import React, { FunctionComponent, useEffect, useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import InputCostComponent from 'widgets/form/input-cost.component';
import { UserDto } from 'stores/users/users-store';
import { EventPositionDto, NewEventSupportPositionsDto } from 'stores/events/events-store';
import { EventFormStore, EventFormViewModel, EventSupportDetailsViewModel } from 'stores/events/event-form-store';
import { DatePeriod } from 'site/pages/landing-pages/shared-scheduler-components/events/scheduler-period-service';
import moment from 'moment';
import { DateTimeService } from 'services/datetime-service';
import TailwindNewInfoSupportDetailedComponent from './tailwind-new-info-support-detailed.component';

interface TailwindNewEventsSupportDetailsProps extends WithTranslation {
  event: EventFormViewModel;
  readonly?: boolean;
  supportDetails: EventSupportDetailsViewModel;
  onChange?: (value: EventSupportDetailsViewModel) => void;
  isHideEditButton: boolean;
  eventFormStore?: EventFormStore;
}

const TailwindNewEventsSupportDetails: FunctionComponent<TailwindNewEventsSupportDetailsProps> = props => {
  const { t, event, readonly, supportDetails, onChange, isHideEditButton, eventFormStore } = props;
  const { newSupportPositions, positionsRequested, totalCost } = supportDetails;
  const [selectedEvent /*, setSelectedEvent*/] = useState<EventFormViewModel>(event);

  const onChangeHandler = (newPosition: NewEventSupportPositionsDto, index: number) => {
    const newSupportPositions = supportDetails.newSupportPositions.map((position, i) =>
      index === i ? (position = newPosition) : position
    );

    onChange({ ...supportDetails, newSupportPositions });
  };

  const sumTotalCosts = newSupportPositions.reduce(
    (prev, { eventNewModelPositions }) => (eventNewModelPositions || []).reduce((p, { actualCost }) => Number(actualCost) + p, 0) + prev,
    0
  );

  useEffect(() => {
    const sd = { ...supportDetails };
    //const { state } = eventFormStore;
    const { startDate, endDate } = selectedEvent;
    const start = DateTimeService.toMoment(startDate);
    const end = DateTimeService.toMoment(endDate);

    (sd.newSupportPositions || []).map((supportPosition, idx) => {
      const notInEventDate = (supportPosition.eventNewModelPositions || []).any(({ startDate, endDate }, i) => {
        const fromDate = DateTimeService.toMoment(startDate);
        const toDate = DateTimeService.toMoment(endDate);
        return start.isAfter(fromDate, 'D') || end.isBefore(toDate, 'D');
      });

      if (notInEventDate) {
        (supportPosition.eventNewModelPositions || []).map(eventNewModelPosition => {
          const enmpStartDate = eventNewModelPosition.startDate;
          const enmpEndDate = eventNewModelPosition.endDate;

          const fromDate = DateTimeService.toMoment(enmpStartDate);
          const toDate = DateTimeService.toMoment(enmpEndDate);

          if (start.isAfter(fromDate, 'D') || start.isAfter(toDate, 'D') || end.isBefore(toDate, 'D')) {
            if (start.isAfter(fromDate, 'D')) eventNewModelPosition.startDate = startDate;
            if (start.isAfter(toDate, 'D')) eventNewModelPosition.endDate = startDate;
            if (end.isBefore(toDate, 'D')) eventNewModelPosition.endDate = endDate;
            return { ...eventNewModelPosition };
          }
          return eventNewModelPosition;
        });
      }

      return null;
    });

    totalCost !== sumTotalCosts && onChange({ ...supportDetails, totalCost: sumTotalCosts });
  }, [sumTotalCosts, onChange, totalCost, supportDetails, eventFormStore, selectedEvent]);

  const onNewPositionHandler = (user: UserDto, dates: DatePeriod, supportPosition: number) => {
    const nextSupportPositions = supportDetails.newSupportPositions.map((newSupportPos, i) => {
      if (supportPosition === i) {
        const newEventPosition: EventPositionDto = {
          actualCost: '',
          actualDays: '',
          actualHours: '',
          startDate: dates ? dates.from : null,
          endDate: dates ? dates.to : null,
          user,
          userId: user.id,
          userLocationId: user.roles.find(x => x.role.name === 'Employee').location.id,
          plannedDays: dates.from && dates.to ? moment(dates.to).diff(moment(dates.from), 'days') + 1 : 0,
          travelDays: null,
          noTravel: false
        };

        newSupportPos.eventNewModelPositions = [...newSupportPos.eventNewModelPositions, newEventPosition];
      }
      return newSupportPos;
    });
    onChange({ ...supportDetails, newSupportPositions: nextSupportPositions });
  };

  return (
    <>
      <div>
        <label className="text-sm text-gray-700">{t('Position Requested')}</label>
        <input className="w-full border border-gray-300 p-2 rounded bg-gray-100" value={positionsRequested} disabled />
      </div>
      <div>
        <label className="text-sm text-gray-700">{t('Total Cost')}</label>
        <InputCostComponent
          className="w-full border border-gray-300 p-2 rounded bg-gray-100"
          onChange={null}
          disabled
          disabledLayout
          value={sumTotalCosts}
        />
      </div>

      {(newSupportPositions || []).map((newSupportPosition, i) => (
        <div key={i} className="bg-gray-50 p-4 rounded-lg mb-4">
          <TailwindNewInfoSupportDetailedComponent
            key={'event-support-position' + i}
            readonly={readonly}
            onNewPosition={(user, dates) => onNewPositionHandler(user, dates, i)}
            {...newSupportPosition}
            onChange={value => onChangeHandler(value, i)}
            isHideEditButton={isHideEditButton}
            //eventFormStore={eventFormStore}
            event={event}
          />
        </div>
      ))}
    </>
  );
};

export default withTranslation()(TailwindNewEventsSupportDetails);
